<template>
  <div class="row product-item-wrapper row-no-gutters">
    <div v-for="item in items" :key="item.text" class="col-xs-12 col-sm-4 col-md-4 col-lg-4 product-item-outer">
      <product-item-img :item="item" />
    </div>
  </div>
</template>
<script>
import ProductItemImg from "./ProductItemImg.vue";
export default {
  components: {
    ProductItemImg,
  },
  data() {
    return {
      items: [
        {
          text: "同慧易财财务系统",
          src: require("../../assets/product/icon-1.png"),
          path: "p1",
        },
        {
          text: "同慧内控资产管理系统",
          src: require("../../assets/product/icon-2.png"),
          path: "p2",
        },
        {
          text: "同慧法院专版财务系统",
          src: require("../../assets/product/icon-3.png"),
          path: "p3",
        },
        {
          text: "同慧内控文件管理系统",
          src: require("../../assets/product/icon-4.png"),
          path: "p4",
        },
        {
          text: "同慧内控人事管理系统",
          src: require("../../assets/product/icon-5.png"),
          path: "p5",
        },
        {
          text: "同慧内控报销系统",
          src: require("../../assets/product/icon-6.png"),
          path: "p6",
        },
      ],
    };
  },
};
</script>
<style scoped>
.product-item-wrapper {
  margin-top: 20px;
  margin-bottom: 40px;
}
.product-item-outer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.product-item-outer:hover{
  background-color: #E9EFFA;
}
.product-item-outer:nth-child(1) {
  border-top: 1px solid #bfbfbf;
  border-left: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  border-top-left-radius: 2px;
}
.product-item-outer:nth-child(2) {
  border-top: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
}
.product-item-outer:nth-child(3) {
  border-top: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  border-top-right-radius: 2px;
}
.product-item-outer:nth-child(4) {
  border-left: 1px solid #bfbfbf;
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  border-bottom-left-radius: 2px;
}
.product-item-outer:nth-child(5) {
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
}
.product-item-outer:nth-child(6) {
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  border-bottom-right-radius: 2px;
}
@media (max-width: 768px) {
  .product-item-outer > .product-item-container {
    border:1px solid #bfbfbf;
    border-radius: 2px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/ProductItem.vue